<template>
  <div class="">
    <edit-insurance-risks> </edit-insurance-risks>
  </div>
</template>

<script>
import EditInsuranceRisks from "@/components/profile/companies-products/insurance-risks/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditInsuranceRisks,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Prodotti",
        path: "module.PROF",
        tab: "#InsurerRisks",
        level: 4,
      });
      bcs.push({
        text: "Modifica Prodotto",
        path: "insurance_risks.edit",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Prodotti",
        path: "module.PROF",
        tab: "#InsurerRisks",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica Prodotto",
        path: "insurance_risks.edit",
        level: 4,
      });
    }
  },
};
</script>
